import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HotMovies() {
  const hotMovies = movies.filter((m) => m.isHot);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">大家都在看的热门影片</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[2/3] mb-3">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-[10px] font-medium rounded">
                    {movie.quality[0]}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-1.5 py-0.5 bg-black/60 text-accent-400 text-[10px] rounded">
                    {movie.rating}
                  </span>
                </div>
                {movie.isNew && (
                  <div className="absolute bottom-2 left-2">
                    <span className="px-2 py-0.5 bg-primary-500 text-white text-[10px] font-medium rounded">
                      NEW
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{movie.subCategory} · {movie.year}</p>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/movie"
            className="flex items-center gap-1 px-5 py-2.5 bg-primary-500 text-white text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}